import type { RecipeAgentKind, RecipeDestinationOption } from '@workspace/types';

export function defaultAssistantName(companyName: string): string {
  const name = companyName.trim();
  return name ? `Asistente ${name}` : 'Asistente';
}

export function defaultReceptionName(companyName: string): string {
  const name = companyName.trim();
  return name ? `Recepción ${name}` : 'Recepción';
}

export function defaultWelcome(companyName: string): string {
  const name = companyName.trim() || 'la empresa';
  return `Hola, te damos la bienvenida a ${name}. Contame qué necesitás y te paso con quien corresponde.`;
}

export const KIND_LABEL: Record<RecipeAgentKind, string> = {
  ASISTENTE: 'Asistente',
  COBRADOR: 'Cobrador',
  VENDEDOR: 'Vendedor',
  MESA: 'Mesa de ayuda',
};

export type ChosenDestination = { botId: string; menuLabel: string };

/** Arranca con todos los agentes elegidos, con el texto de menú propuesto. */
export function initialDestinations(options: RecipeDestinationOption[]): ChosenDestination[] {
  return options.map(option => ({ botId: option.botId, menuLabel: option.suggestedLabel }));
}

/** El menú de WhatsApp corta los botones a 24 caracteres. */
export const MENU_LABEL_MAX = 24;
